import { render, staticRenderFns } from "./productLisenceDetail.vue?vue&type=template&id=af8ff500&scoped=true"
import script from "./productLisenceDetail.vue?vue&type=script&lang=js"
export * from "./productLisenceDetail.vue?vue&type=script&lang=js"
import style0 from "./productLisenceDetail.vue?vue&type=style&index=0&id=af8ff500&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8ff500",
  null
  
)

export default component.exports